__turbopack_context__.v({
  "ctaBtn": "styles-module-scss-module__kqWvrW__ctaBtn",
  "paddingBottom": "styles-module-scss-module__kqWvrW__paddingBottom",
  "root": "styles-module-scss-module__kqWvrW__root",
});
